export const USN_THRESHOLD_60 = 60000000;
export const USN_THRESHOLD_250 = 250000000;
export const USN_THRESHOLD_450 = 450000000;
export const PSN_THRESHOLD_60 = 60000000;
export const AUSN_THRESHOLD_60 = 60000000;
